import React from "react";

type ChatFinePrintVariant = "dark" | "light";

interface ChatFinePrintProps {
  assistantName?: string;
  className?: string;
  style?: React.CSSProperties;
  variant?: ChatFinePrintVariant;
}

const getChatFinePrintText = (assistantName: string) =>
  `${assistantName} can make mistakes. Please verify important information before relying on it.`;

const ChatFinePrint: React.FC<ChatFinePrintProps> = ({
  assistantName = "FXGPT",
  className,
  style,
  variant = "dark",
}) => {
  const isLight = variant === "light";

  return (
    <div
      className={className}
      style={{
        width: "100%",
        color: isLight ? "rgba(15, 23, 42, 0.58)" : "rgba(255, 255, 255, 0.58)",
        fontSize: "10px",
        lineHeight: "14px",
        letterSpacing: "0.01em",
        textAlign: "center",
        pointerEvents: "none",
        ...style,
      }}
    >
      {getChatFinePrintText(assistantName)}
    </div>
  );
};

export default ChatFinePrint;
